module.exports = __webpack_public_path__ + "img/txt.acafeac8.svg";